module.exports = __webpack_public_path__ + "img/esuco-sa.66e27588.jpg";